import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Auto-refresh session on 401 (single-flight), redirect on 402 (subscription required)
let refreshPromise = null;
const NO_RETRY = ["/auth/login", "/auth/register", "/auth/refresh", "/auth/logout", "/auth/google/session"];
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const { config, response } = err;
    if (
      response?.status === 401 &&
      config &&
      !config._retry &&
      !NO_RETRY.some((p) => (config.url || "").includes(p))
    ) {
      config._retry = true;
      try {
        if (!refreshPromise) {
          refreshPromise = axios
            .post(`${API}/auth/refresh`, {}, { withCredentials: true })
            .finally(() => { refreshPromise = null; });
        }
        await refreshPromise;
        return api(config);
      } catch (_e) {
        void _e; // refresh failed — fall through to original 401
      }
    }
    if (response?.status === 402) {
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/subscription")) {
        window.location.href = "/subscription";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
